<div [ngStyle]="{'background-image':'url(' + photo + ')'}" class="header">
    <app-navbar id="navbar"></app-navbar>
    <h1 class="title is-2">{{title}}</h1>
</div>
